<header (click)="onClick()">
  <div class="icon">{{ icon() }}</div>
  <div>
    <div class="title-sm title">{{ title() | translate }}</div>
    <p class="body-md summary">{{ summary() }}</p>
  </div>

  @if (shouldDisplayCta()) {
    <div class="cta">
      @if (state() === 'todo') {
        <button
          smw-button
          kind="filled-inversed"
          [disabled]="isDisabled()"
          [tooltip]="ctaTooltip()"
          (click)="onClick()"
        >
          {{ ctaLabel() | translate }}
        </button>
      } @else {
        <button
          smw-button
          kind="icon"
          [icon]="preparedCtaIcon()"
          [tooltip]="ctaTooltip()"
          [disabled]="isDisabled()"
          (click)="onClick()"
        ></button>
      }
    </div>
  }
</header>

@if (shouldDisplayContent()) {
  <div class="content">
    @if (onSmallScreen()) {
      <div class="mobile-header">
        <button
          smw-button
          kind="icon"
          class="close"
          [icon]="closeMobileViewIcon"
          (click)="showContent.set(false)"
        ></button>
        @if (ctaAllowed()) {
          @if (enableFabCta()) {
            <button smw-fab [disabled]="isDisabled()" (click)="onClick()"></button>
          } @else {
            <button
              smw-button
              kind="filled"
              [disabled]="isDisabled()"
              [tooltip]="ctaTooltip()"
              (click)="onClick()"
            >
              {{ ctaLabel() | translate }}
            </button>
          }
        }
      </div>
    }
    <ng-content />
  </div>
}
